var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../../utils';
export var Radio = function (_a) {
    var id = _a.id, checked = _a.checked, icon = _a.icon, customIcon = _a.customIcon, description = _a.description, isActivity = _a.isActivity, variant = _a.variant, extraButtonIcon = _a.extraButtonIcon, disabled = _a.disabled, extraButtonOnClick = _a.extraButtonOnClick, rest = __rest(_a, ["id", "checked", "icon", "customIcon", "description", "isActivity", "variant", "extraButtonIcon", "disabled", "extraButtonOnClick"]);
    var getContainerStyle = function () {
        if (isActivity) {
            return "text-textMid flex items-center rounded-lg p-4 ".concat(checked ? 'bg-secondaryAccent2' : 'bg-uiBg');
        }
        if (variant === 'slim') {
            return "text-textDark flex rounded-lg p-4 ".concat(checked ? 'bg-secondaryAccent2 border-secondary border-2' : 'bg-uiBg');
        }
        return "text-textDark flex items-center rounded-lg p-4 ".concat(checked ? 'bg-secondaryAccent2 border-secondary border-2' : 'bg-uiBg');
    };
    var getInputStyle = function () {
        if (variant === 'slim') {
            return "mr-2 mt-1 h-4 w-4 ".concat(checked
                ? 'text-secondary border-secondary'
                : 'text-tertiary border-primaryAccent2', " focus:outline-none ring-transparent");
        }
        return "mr-2 h-5 w-5 ".concat(checked
            ? 'text-secondary border-secondary'
            : 'text-tertiary border-tertiary', " focus:outline-none ring-transparent");
    };
    var getLabelStyle = function () {
        var base = 'flex w-full items-center gap-2';
        if (isActivity) {
            return base;
        }
        if (variant === 'slim') {
            return "".concat(base, " text-sm");
        }
        return "".concat(base, " font-bold");
    };
    return (_jsxs("label", __assign({ htmlFor: id, className: classNames('relative items-center', getContainerStyle()) }, { children: [_jsx("input", __assign({}, rest, { type: "radio", id: id, checked: checked, disabled: disabled, className: getInputStyle() })), _jsxs("div", __assign({ className: getLabelStyle() }, { children: [customIcon, icon && !customIcon && (_jsx("span", __assign({ className: "flex h-9 w-9 items-center justify-center rounded-full ".concat(checked ? 'bg-secondary' : 'bg-tertiary') }, { children: icon }))), description, extraButtonIcon && (_jsx("button", __assign({ className: "ml-auto", onClick: extraButtonOnClick }, { children: extraButtonIcon })))] })), disabled && (_jsx("span", { className: "rounded-10 absolute left-0 top-0 h-full w-full bg-gray-100 opacity-50" }))] })));
};
//# sourceMappingURL=index.js.map